import React, {useEffect, useState, useRef} from 'react';
import BrandMark from "./BrandMark";
import {useNavigate} from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";
import {selectUserData} from "../selectors";
import { useSelector } from "react-redux";
import { BookOpenIcon, BrainIcon, CameraIcon, CircleUserIcon, ClipboardListIcon, CodeIcon, CreditCardIcon, FlaskConicalIcon, FlipHorizontal2Icon, ImageIcon, ImagePlusIcon, ImagesIcon, LayoutDashboardIcon, MailIcon, MessageSquareIcon, MessagesSquareIcon, NotebookIcon, ShirtIcon, SmileIcon, StarIcon, TagsIcon, UserIcon, UsersIcon, WandSparklesIcon } from "lucide-react";

const Sidebar = React.forwardRef((props, ref) => {
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();
    const [options, setOptions] = React.useState({
        "/myimages": { text: "My Gallery", icon: ImageIcon },
        "/agent": { text: "Ask TryOn", icon: MessageSquareIcon },
        "/model-generator": { text: "Model Generator", icon: UserIcon },
        "/tryonai": { text: "Virtual Try-On", icon: ShirtIcon },
        "/aimodel": { text: "Model Swap", icon: SmileIcon },
        "/reimagineai": { text: "Reimagine", icon: WandSparklesIcon },
        "/generate": { text: "Generate", icon: BrainIcon },
        "/tryonstudio": { text: "Studio", icon: FlipHorizontal2Icon },
        "/credits": { text: "Credits", icon: CreditCardIcon },
        "/profile": { text: "Profile", icon: CircleUserIcon },
        "/pricing": { text: "Pricing", icon: TagsIcon },
        "/docs": { text: "Documentation", icon: NotebookIcon },
        "/admin/dashboard": { text: "Dashboard", icon: LayoutDashboardIcon },
        "/admin/useronboardingdetails": { text: "User Onboarding Details", icon: ClipboardListIcon },
        "/admin/users": { text: "Users", icon: UsersIcon },
        "/admin/experiments": { text: "Experiments", icon: FlaskConicalIcon }
    });

    let adminOptions = [
        "/admin/dashboard",
        "/admin/useronboardingdetails",
        "/admin/users",
        "/admin/experiments"
    ]
    const location = useLocation();
    const sidebarRef = useRef(null);
    const isMobile1 = useMediaQuery({ query: `(max-width: 760px)` })
    const userData = JSON.parse(useSelector(selectUserData));

    useEffect(() => {
        console.log("props.options", props.options.isAdmin, userData)

        const handleResize = () => {
            console.log("innerWidth", window.innerWidth)
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                console.log("is mobile:", isMobile1)

                if(isMobile1){
                    props.closeSideBar();
                }
            }
          };

        window.addEventListener('mousedown', handleClickOutside);
        
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('mousedown', handleClickOutside)
        };
    }, []);

    function handleSelectOption(option) {
        console.log("handleSelectOption inside sidebar: ", option)
        if (props.isSidebarOpen && isMobile) {
            props.closeSideBar();
        }
        let options1 = props.options;
        console.log("options1 before", options1)
        Object.keys(options1).forEach((key) => {
            if (key === option) {
                options1[key] = true;
            } else {
                options1[key] = false;
            }
        })
        console.log("options1 after", options1)
        props.handleOptionSelect(option, options1);
    }

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const rail = Boolean(props.collapsed);

    return (
        <div ref={ref}>
            {
                (props.isSidebarOpen || !isMobile1) &&
                (<div className="relative md:static md:w-auto">

                    <aside id="sidebar-multi-level-sidebar"
                           className={`fixed top-0 left-0 z-40 flex h-screen w-full translate-x-0 flex-col overflow-x-hidden border-r border-hairline bg-white transition-[width] duration-200 ${rail ? "md:w-[4.5rem]" : "md:w-64"}`}
                           aria-label="Sidebar">

                        <div className={`flex w-full min-w-0 shrink-0 items-center gap-3 px-4 py-4 ${rail ? "md:flex-col md:gap-2 md:px-2" : "md:px-3"}`}>
                            <button
                                type="button"
                                className={`flex min-w-0 flex-1 items-center rounded-lg hover:bg-hover-tint ${rail ? "gap-3 px-1 py-2 md:flex-none md:justify-center md:px-0" : "gap-3 px-1 py-2"}`}
                                onClick={() => handleSelectOption("/")}
                            >
                                <BrandMark />
                                <span className={`flex min-w-0 flex-col text-left ${rail ? "md:hidden" : ""}`}>
                                    <span className="truncate font-Mulish text-xl font-semibold leading-none text-secondary">
                                        TryOn AI
                                    </span>
                                    <span className="mt-1 truncate font-Mulish text-sm text-graphite">
                                        Playground
                                    </span>
                                </span>
                            </button>
                            <button
                                type="button"
                                onClick={() => props.closeSideBar()}
                                aria-label="Close sidebar"
                                className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-primary-700 shadow-[0_0_0_1px_var(--hairline)] md:hidden"
                            >
                                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                            <button
                                type="button"
                                onClick={props.toggleCollapsed}
                                aria-label={rail ? "Expand sidebar" : "Collapse sidebar"}
                                aria-expanded={!rail}
                                className="hidden h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-primary-700 shadow-[0_0_0_1px_var(--hairline)] md:flex"
                            >
                                <svg className={`h-4 w-4 transition-transform ${rail ? "rotate-180" : ""}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>
                        </div>

                        <div className="flex-1 overflow-y-auto px-3">
                            {props.options ? (
                                <div className="space-y-1">
                                    {Object.keys(props.options).map((option, key) => {
                                        if (option.includes("/admin") && !userData?.is_staff) {
                                            return null;
                                        }
                                        if (!options[option]) {
                                            return null;
                                        }
                                        const selected = props.options[option];
                                        return (
                                            <li
                                                key={key}
                                                title={options[option].text}
                                                className={`flex w-full cursor-pointer items-center rounded-lg border-l-2 py-2.5 ${rail ? "gap-2.5 px-3 md:justify-center md:px-2" : "gap-2.5 px-3"} ${selected ? "border-primary-500 bg-primary-50" : "border-transparent hover:bg-hover-tint"}`}
                                                onClick={() => handleSelectOption(option)}
                                            >
                                                <a
                                                    href="#"
                                                    aria-label={options[option].text}
                                                    className={`flex items-center ${rail ? "gap-2 md:justify-center md:gap-0" : "gap-2"} ${selected ? "font-Mulish font-semibold text-secondary" : "font-Mulish text-graphite"}`}
                                                >
                                                    {React.createElement(options[option].icon, { className: `h-5 w-5 shrink-0 ${selected ? "text-primary-700" : "text-graphite"}` })}
                                                    <span className={`ms-3 ${rail ? "md:hidden" : ""}`}>{options[option].text}</span>
                                                </a>
                                            </li>
                                        );
                                    })}
                                </div>) : (<></>)}
                        </div>

                        <div className="shrink-0 border-t border-hairline px-3 py-4">
                            <div className="space-y-1">
                                <div title="Visit GitHub" className={`group flex cursor-pointer items-center rounded-lg py-2 font-Mulish text-sm text-graphite hover:text-secondary ${rail ? "gap-3 px-3 md:justify-center md:px-2" : "gap-3 px-3"}`} onClick={() => window.open("https://github.com/tryonlabs", "_blank")}>
                                    <CodeIcon className="h-5 w-5 shrink-0 text-graphite group-hover:text-secondary"/>
                                    <span className={rail ? "md:hidden" : ""}>Visit GitHub</span>
                                </div>

                                <div title="Join Discord" className={`group flex cursor-pointer items-center rounded-lg py-2 font-Mulish text-sm text-graphite hover:text-secondary ${rail ? "gap-3 px-3 md:justify-center md:px-2" : "gap-3 px-3"}`} onClick={() => window.open("https://discord.gg/SuM5Xr9nn9", "_blank")}>
                                    <MessagesSquareIcon className="h-5 w-5 shrink-0 text-graphite group-hover:text-secondary"/>
                                    <span className={rail ? "md:hidden" : ""}>Join Discord</span>
                                </div>

                                <div title="Contact Us" className={`group flex cursor-pointer items-center rounded-lg py-2 font-Mulish text-sm text-graphite hover:text-secondary ${rail ? "gap-3 px-3 md:justify-center md:px-2" : "gap-3 px-3"}`} onClick={() => window.open("mailto:contact@tryonlabs.ai", "_blank")}>
                                    <MailIcon className="h-5 w-5 shrink-0 text-graphite group-hover:text-secondary"/>
                                    <span className={rail ? "md:hidden" : ""}>Contact Us</span>
                                </div>
                            </div>
                        </div>
                    </aside>
                </div>)
            }
        </div>
    )
})

export default Sidebar;
